import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

var _this = this;

import * as tslib_1 from "tslib";
import _ from 'lodash';
import { Durations, AssetType, OrderAction, PositionEffect, OrderActionDirection, SizeRatio } from '@tradingblock/types';
import { tryValidate, SchemaValidator } from './strategyValidator';
export var baseOccPattern = function baseOccPattern() {
  var optionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PC';
  return new RegExp('([\\s]{3})([\\w]{3,6})(\\d{2})(\\d{2})(\\d{2})([' + optionType + '])(\\d{5,8})');
}; //export const occSymbolPattern = /([\s]{3})([\w]{3,6})(\d{2})(\d{2})(\d{2})([PC])(\d{5,8})/g;

export var occSymbolPattern = baseOccPattern();
export var legSchemaBuilder = function legSchemaBuilder(_ref, sizeRatio) {
  var spreadRatio = _ref.spreadRatio,
      assetType = _ref.assetType,
      action = _ref.action,
      optionType = _ref.optionType;
  var requiredFields = ['UnderlyingSymbol', 'AssetType', 'Action', 'PositionEffect', 'Symbol'];

  if (assetType === AssetType.Option) {
    requiredFields = [].concat(_toConsumableArray(requiredFields), ['Expiration', 'Strike']);
  }

  var isSpread = sizeRatio !== SizeRatio.NA;

  if (isSpread) {
    requiredFields = [].concat(_toConsumableArray(requiredFields), ['SpreadRatio']);
  }

  var legSchema = {
    type: 'object',
    required: requiredFields,
    properties: {
      UnderlyingSymbol: {
        type: 'string'
      },
      SpreadRatio: isSpread ? {
        type: 'number'
      } : {
        anyOf: [{
          type: 'number'
        }, {
          const: undefined
        }]
      },
      AssetType: {
        enum: _.isArray(assetType) ? assetType : [assetType]
      },
      Strike: assetType === AssetType.Option ? {
        type: 'number'
      } : {
        const: undefined
      },
      Action: _.isArray(action) ? {
        enum: action
      } : {
        type: 'number'
      },
      PositionEffect: {
        enum: [PositionEffect.Open, PositionEffect.Close]
      },
      // Strike: assetType === AssetType.Option ? { type: 'number' } : undefined,
      Symbol: {
        type: 'string'
      },
      OptionType: {
        const: optionType
      }
    }
  };
  return legSchema;
};

var orderSchemaBuilder = function orderSchemaBuilder(orderClass, legSchema, spreadRatio, moreProperties) {
  var _a = _.merge(moreProperties, {
    Strike: undefined,
    Expiration: undefined,
    Direction: undefined
  }),
      Strike = _a.Strike,
      Expiration = _a.Expiration,
      Direction = _a.Direction,
      rest = tslib_1.__rest(_a, ["Strike", "Expiration", "Direction"]);

  return {
    required: ['OrderClass', 'Duration', 'Legs'],
    properties: Object.assign({
      OrderClass: {
        const: orderClass
      },
      Duration: {
        enum: [Durations.GTC, Durations.Day, Durations.Manual]
      },
      Legs: {
        minItems: legSchema.length,
        maxItems: legSchema.length,
        type: 'array',
        items: _.map(legSchema, function (l) {
          return legSchemaBuilder(l, spreadRatio);
        }),
        strike: Strike,
        expiration: Expiration,
        ratio: spreadRatio,
        action: Direction
      }
    }, rest || {})
  };
};

function isActionLegSchema(val) {
  if (val && _.get(val, 'action', false)) {
    return true;
  }

  return false;
}

var buildValidationSchemas = function buildValidationSchemas(strategy) {
  var legsDef = _.map(strategy.profile.Legs, function (l) {
    var legSchem = {
      assetType: l.AssetType,
      spreadRatio: l.SpreadRatio,
      optionType: l.OptionType
    };

    if (l.Direction) {
      return Object.assign({}, legSchem, {
        action: l.Direction === OrderActionDirection.Long ? OrderAction.Buy : OrderAction.Sell
      });
    }

    return legSchem;
  });

  var additionalRules = strategy.profile.Rules ? {
    Strike: strategy.profile.Rules.Strike,
    Expiration: strategy.profile.Rules.Expiration,
    Direction: strategy.profile.Rules.Direction
  } : {};
  var orderSchema = orderSchemaBuilder(strategy.profile.OrderClass, legsDef, strategy.profile.Rules.SpreadRatio, additionalRules);
  var inverseOrderSchema = strategy.profile.Bidirectional ? orderSchemaBuilder(strategy.profile.OrderClass, legsDef.map(function (ll) {
    if (isActionLegSchema(ll)) {
      return Object.assign({}, ll, {
        action: ll.action === OrderAction.Buy ? OrderAction.Sell : OrderAction.Buy
      });
    }

    return ll;
  }), strategy.profile.Rules.SpreadRatio, additionalRules) : undefined;
  return {
    buySchema: orderSchema,
    sellSchema: inverseOrderSchema
  };
};

export var tryValidateOrderForStrategy = function tryValidateOrderForStrategy(ajv, strategy, order) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var schemas, _ref2, _ref3, validationResults, inverseValidationResults;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            schemas = buildValidationSchemas(strategy);
            _context.next = 3;
            return Promise.all([tryValidate(ajv, schemas.buySchema, order), schemas.sellSchema ? tryValidate(ajv, schemas.sellSchema, order) : Promise.resolve(undefined)]);

          case 3:
            _ref2 = _context.sent;
            _ref3 = _slicedToArray(_ref2, 2);
            validationResults = _ref3[0];
            inverseValidationResults = _ref3[1];
            return _context.abrupt("return", {
              order: order,
              sell: {
                isValid: inverseValidationResults && inverseValidationResults.valid ? true : false,
                results: inverseValidationResults
              },
              buy: {
                isValid: validationResults && validationResults.valid ? true : false,
                results: validationResults
              }
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var tryValidateOrder = function tryValidateOrder(ajv, strategy, order) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var schemas, res, inverse, isVal, isInverseValid;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            schemas = buildValidationSchemas(strategy);
            _context2.next = 3;
            return tryValidate(ajv, schemas.buySchema, order);

          case 3:
            res = _context2.sent;

            if (!schemas.sellSchema) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return tryValidate(ajv, schemas.sellSchema, order);

          case 7:
            _context2.t0 = _context2.sent;
            _context2.next = 11;
            break;

          case 10:
            _context2.t0 = undefined;

          case 11:
            inverse = _context2.t0;
            isVal = res.valid ? res.valid : inverse ? inverse.valid : false;
            isInverseValid = isVal && inverse && inverse.valid ? true : false; // console.log(strategy.info.Name, res, inverse);

            return _context2.abrupt("return", {
              isInverse: isInverseValid,
              valid: isVal,
              validationResults: res,
              inverseValidationResults: inverse
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var validateOrder = function validateOrder(strategy, order) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return tryValidateOrder(SchemaValidator(), strategy, order);

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var validateOrderForStrategy = function validateOrderForStrategy(strategy, order) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return tryValidateOrderForStrategy(SchemaValidator(), strategy, order);

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
export var isValid = function isValid(strategy, order) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return validateOrder(strategy, order).then(function (res) {
              return res.valid;
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};